export abstract class Constants {
  static readonly PAGE_SIZE: number = 50
}
